import { useCallback } from 'react';
import { Box } from '@mui/material';

import { Button, convertToDataTestId } from '@qrios/frontend-library';

import { authentication } from '../../../../authentication';

interface ButtonProps {
  text: string;
  onClickHandler: (props?: unknown) => unknown;
  isLoading?: boolean;
  isDisabled?: boolean;
}

interface Props {
  primaryButton: ButtonProps;
}

const StepperFooter = ({ primaryButton }: Props) => {
  const handleBackToLogin = useCallback(() => {
    authentication.logout();
  }, []);

  return (
    <>
      <Box mt={3} display="flex" flexDirection="row">
        <Box width="50%" pr={1}>
          <Button
            fullWidth
            onClick={handleBackToLogin}
            text="Back to login page"
            data-testid="button-back-to-login"
            variant="outlined"
          />
        </Box>
        <Box width="50%">
          <Button
            fullWidth
            loading={primaryButton.isLoading === undefined ? false : primaryButton.isLoading}
            onClick={primaryButton.onClickHandler}
            text={primaryButton.text}
            disabled={primaryButton.isDisabled === undefined ? false : primaryButton.isDisabled}
            data-testid={`button-${convertToDataTestId(primaryButton.text)}`}
          />
        </Box>
      </Box>
    </>
  );
};

export default StepperFooter;
